export const currentBloggerGroupsModalName = 'current-blogger-groups';
